export default __webpack_public_path__ + "static/media/binSPIRIT.45823495.svg";